(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-data/create-game/assets/javascripts/helpers/get-product-items.js') >= 0) return;  svs.modules.push('/components/marketplace-data/create-game/assets/javascripts/helpers/get-product-items.js');
"use strict";


const {
  BUY_STOP_DIFF,
  DISABLED_REASONS
} = svs.components.marketplaceData.createGame.constants;
const {
  NO_DRAW,
  MINIMUM_DIFF_TO_DRAW_PASSED
} = DISABLED_REASONS;
const getProductItems = function (allProductNames, drawsByProduct) {
  let buyStop = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : BUY_STOP_DIFF;
  const minimumBufferInMs = buyStop * 60 * 1000;
  const now = Date.now();
  const latestClosingTime = new Date(now + minimumBufferInMs);
  return allProductNames.map(item => {
    const drawsForProduct = drawsByProduct[item];
    if ((drawsForProduct || []).length === 0) {
      return {
        item,
        disabledReason: NO_DRAW,
        isDisabled: true
      };
    }
    const disabledReason = drawsForProduct.some(draw => new Date(draw.regCloseTime) > latestClosingTime) ? undefined : MINIMUM_DIFF_TO_DRAW_PASSED;
    return {
      item,
      disabledReason,
      isDisabled: Boolean(disabledReason)
    };
  });
};
setGlobal('svs.components.marketplaceData.createGame.helpers.getProductItems', getProductItems);

 })(window);